import { P2GCard, P2GFade } from '@parcel2go/core-ui';

interface AppSurfaceProps {
  children?: React.ReactNode;
  className?: string;
}

export const AppSurface = ({ children, className }: AppSurfaceProps) => {
  return (
    <P2GFade in timeout={300}>
      <P2GCard
        sx={(t) => ({
          boxShadow: `0 0 10px 5px ${t.palette.grey.A200}`,
          borderRadius: t.spacing(2),
          backgroundColor: 'white',
          padding: { xs: t.spacing(2), sm: t.spacing(4) }
        })}
        classNames={[className, 'p2g-app-surface']}
        style={{ maxHeight: 'unset' }}
      >
        {children}
      </P2GCard>
    </P2GFade>
  );
};
